import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { CookieHelper } from '../cookie-helper';

@Component({
  selector: 'ngc-cookie-banner',
  templateUrl: 'cookie-banner.component.html'
})
export class CookieBannerComponent implements OnInit, AfterViewInit, OnDestroy {
  showCookieTerms = false;
  prefCookieValue: any;
  langPrefCookie: any;
  cookieDetails: any;
  countryLangCookie: any;
  langVal: any;
  classVal: boolean;
  descContainer: any;
  skipEle: any;
  logoEle: any;
  focusableEls: any = [];
  firstFocusableEl: any = [];
  lastFocusableEl: any = [];
  isLightFooterEnabled: boolean;
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cookieHelper: CookieHelper,
    private contentService: ContentHeaderFooterService,
    private commonService: CommonService,
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.prefCookieValue = this.cookieHelper.getCookies('DL_PER');
    this.langPrefCookie = this.cookieHelper.getCookies('prefUI');
    this.countryLangCookie = this.cookieHelper.getCookies('CTY_LANG');
  }

  closeCookieBanner() {
    this.showCookieTerms = false;
  }

  @HostListener('window:click', ['$event'])
  @HostListener('window:keyup', ['$event'])
  @HostListener('window:keydown', ['$event'])
  @HostListener('window:keypress', ['$event'])
  onEvent(event: any) {
    const element = document.querySelectorAll('ngc-global-footer ngc-cookie-banner');
    const elementDisplay = window.getComputedStyle(element[0]).getPropertyValue('display');
    if (
      document.querySelector('.cookie-desc-container') !== undefined &&
      document.querySelector('.cookie-desc-container') !== null && elementDisplay !== 'none'
    ) {
      if (
        document
          .querySelector('.cookie-desc-container')
          .classList.contains('descFocus') === true
      ) {
        document
          .querySelector('.cookie-desc-container')
          .classList.remove('descFocus');
      }
      if (
        event.target.classList.contains('cookie-footer') ||
        event.target.classList.contains('outer-cookie-container') ||
        event.target.classList.contains('cookie-row')
      ) {
        this.descContainer.focus();
      }
    }
    if (this.langPrefCookie !== null) {
      this.langVal = this.commonService.splitCookieArray(
        this.langPrefCookie
      )[1].split['-'];
    }
    const classVal = this.commonService.doesClassExists(
      'lang-modal-content',
      'fsrButton',
      'session-time-out-container',
      'carouselcontainer',
      'lang-selct-confirm-modal-content'
    );
    if (
      event.target.classList.contains('cookie-footer-container') === false &&
      event.target.classList.contains('cookie-desc') === false &&
      event.target.classList.contains('cookie-desc-container') === false &&
      event.target.classList.contains('cookie-banner-content') === false &&
      event.target.classList.contains('cookie-close-icon') === false &&
      event.target.classList.contains('outer-cookie-container') === false &&
      event.target.classList.contains('cookie-row') === false &&
      event.target.parentElement &&
      event.target.parentElement.classList.contains('cookie-banner-content') ===
        false &&
      classVal === false
    ) {
      this.closeCookieBanner();
    }
    if (
      this.commonService.doesClassExists('lang-selct-confirm-modal-content') ===
        true &&
      event.target.classList.contains('sec-lang-confirm-button')
    ) {
      this.cookieHelper.setCookies('CTY_LANG', true);
    }
  }

  ngOnInit() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe((data) => {
                  const contentData = data;
                  this.isLightFooterEnabled =
                    this.commonService.checkLightHeaderFooter();
                  if (contentData && contentData.cookiePolicy) {
                    this.cookieDetails = contentData.cookiePolicy;
                  } else {
                    this.cookieDetails = null;
                  }

                  if (this.prefCookieValue === null) {
                    this.showCookieTerms = true;
                    this.cookieHelper.setCookies('DL_PER', true);
                    if (
                      this.commonService.splitCookieString(
                        this.langPrefCookie
                      ) !== 'en-us'
                    ) {
                      this.cookieHelper.setCookies('CTY_LANG', true);
                    }
                  } else if (
                    this.commonService.splitCookieString(
                      this.prefCookieValue
                    ) === 'true' &&
                    this.commonService.splitCookieString(
                      this.langPrefCookie
                    ) !== 'en-us' &&
                    this.commonService.splitCookieString(
                      this.countryLangCookie
                    ) === 'true' &&
                    this.commonService.doesClassExists('lang-modal-content') ===
                      false
                  ) {
                    this.showCookieTerms = true;
                    this.cookieHelper.setCookies('CTY_LANG', false);
                  } else if (
                    this.commonService.splitCookieString(
                      this.prefCookieValue
                    ) === 'true' &&
                    this.commonService.splitCookieString(
                      this.countryLangCookie
                    ) !== 'true'
                  ) {
                    this.showCookieTerms = false;
                  }
                });
          }
        }
      });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.descContainer = this.elementRef.nativeElement.querySelector(
          '.cookie-desc-container'
        );
        if (this.descContainer) {
          this.descContainer.focus();
          this.descContainer.classList.add('descFocus');
          this.trapFocusInsideModal(this.elementRef);
        }
      }, 2000);
    }
  }

  trapFocusInsideModal(el) {
    const activeModalElement = el.nativeElement.children[0];
    if (activeModalElement) {
      const tabbableEls = activeModalElement.querySelectorAll(`a[href],
          area[href],
          input:not([disabled]),
          select:not([disabled]),
          textarea:not([disabled]),
          button:not([disabled]),
          [tabindex="0"]`);
      const filter = Array.prototype.filter;
      this.modalElementsFocus(filter, tabbableEls, activeModalElement);
      this.focusableEls = Array.prototype.slice.call(this.focusableEls);
      this.firstFocusableEl = this.focusableEls[0];
      this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
      this.focusableEls = activeModalElement.querySelectorAll(
        'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
      );
      const KEYCODE_TAB = 9;
      this.modalTabEvent(KEYCODE_TAB, activeModalElement);
    }
  }

  modalElementsFocus(filter, tabbableEls, activeModalElement) {
    this.focusableEls = filter.call(tabbableEls, (el) => {
      let elCopy = el;
      while (elCopy !== activeModalElement) {
        const displayVal = window
          .getComputedStyle(elCopy, null)
          .getPropertyValue('display');
        const visibilityVal = window
          .getComputedStyle(elCopy, null)
          .getPropertyValue('visibility');
        if (displayVal !== 'none' && visibilityVal !== 'hidden') {
          elCopy = elCopy.parentNode;
        } else {
          return false;
        }
      }
      return true;
    });
  }

  modalTabEvent(KEYCODE_TAB, activeModalElement) {
    activeModalElement.addEventListener('keydown', (e: any) => {
      if (e.key === 'Tab' || e.keyCode === KEYCODE_TAB) {
        if (e.shiftKey) {
          if (document.activeElement === this.firstFocusableEl) {
            this.lastFocusableEl.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === this.lastFocusableEl) {
            if (this.isLightFooterEnabled === true) {
              if (document.getElementsByClassName('logoTrim').length !== 0) {
                this.logoEle =
                  document.getElementsByClassName('logoTrim')[0].parentElement;
                if (this.logoEle !== undefined && this.logoEle !== null) {
                  this.logoEle.focus();
                }
                e.preventDefault();
              }
            } else {
              this.skipEle = document.getElementById('skip-main-content');
              if (this.skipEle !== undefined && this.skipEle !== null) {
                this.skipEle.focus();
              }
              e.preventDefault();
            }
          }
        }
      }
    });
  }

  ngOnDestroy() {
    // Loadtest ObsUnsub added
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
